import moment, { Moment } from "moment-timezone";
import { StreamProvider } from "@teamrota/shiftstreamlib";

export interface FilterType {
  provider: StreamProvider | "all";
  account: number | "all";
  client: number | "all";
  role: number | "all";
  venue: number | "all";
  startDate: Moment | null;
  endDate: Moment | null;
  includeFilled: boolean;
  includeUnmapped: boolean;
}

/**
 * Return the default filter state
 */
export function getDefaultFilterState(): FilterType {
  return {
    provider: "all",
    account: "all",
    client: "all",
    role: "all",
    venue: "all",
    startDate: null,
    endDate: null,
    includeFilled: true,
    includeUnmapped: false,
  };
}

/**
 * Return the saved filter state
 */
export function getSavedFilterState(): FilterType {
  // see if localstorage has saved filters
  const savedFilters = localStorage.getItem("shiftStreamStreamFilters");
  if (savedFilters) {
    try {
      const parsedFilters = JSON.parse(savedFilters);

      if (parsedFilters.startDate) {
        const startMoment = moment(parsedFilters.startDate);
        if (startMoment.isValid()) {
          parsedFilters.startDate = startMoment;
        } else {
          parsedFilters.startDate = null;
        }
      }

      if (parsedFilters.endDate) {
        const endMoment = moment(parsedFilters.endDate);
        if (endMoment.isValid()) {
          parsedFilters.endDate = endMoment;
        } else {
          parsedFilters.endDate = null;
        }
      }

      const providerValues = Object.values(StreamProvider) as string[];
      if (parsedFilters.provider === StreamProvider.ALLOCATE) {
        parsedFilters.provider = StreamProvider.ALLOCATEV12;
      }
      if (
        parsedFilters.provider !== "all" &&
        !providerValues.includes(parsedFilters.provider)
      ) {
        parsedFilters.provider = "all";
      }

      return { ...getDefaultFilterState(), ...parsedFilters };
    } catch (e) {
      console.error("Error parsing saved filters from localStorage", e);
    }
  }

  return getDefaultFilterState();
}

export function saveFilterState(filters: FilterType) {
  localStorage.setItem("shiftStreamStreamFilters", JSON.stringify(filters));
}
